<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <vs-popup classContent="popup-example" title="Update Status" :active.sync="popup">
          <template>
          <ul class="centerx">
            <li>
              <vs-radio color="success" v-model="selected" vs-value="ดำเนินการแล้ว">ดำเนินการแล้ว</vs-radio>
            </li>
            <li>
              <vs-radio color="warning" v-model="selected" vs-value="กำลังดำเนินการ">กำลังดำเนินการ</vs-radio>
            </li>
            <li>
              <vs-radio color="danger" v-model="selected" vs-value="ยกเลิก">ยกเลิก</vs-radio>
            </li>
          </ul>
          </template>
          <br>
          <vs-button color="primary" type="filled" @click="updateStatus">Save</vs-button>
        </vs-popup>
        <vs-popup classContent="popup-example" title="เพิ่มการแจ้งฝาก" :active.sync="popup2">
          <template>
            <v-select label="code" v-model="userId" :options="userOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            <div class="centerx">
              <vs-input-number v-model="qty" label="จำนวนเงิน :"/>
            </div>
          </template>
          <br>
          <vs-button color="primary" type="filled" @click="createDeposit">Save</vs-button>
        </vs-popup>
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ usersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : usersData.length }} of {{ usersData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown vs-trigger-click class="cursor-pointer">

            <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
              <span class="mr-2 leading-none">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="Add()">
                <span class="flex items-center">
                  <feather-icon icon="UserPlusIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Add</span>
                </span>
              </vs-dropdown-item>

              <!--vs-dropdown-item @click="Delete()">
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </!--vs-dropdown-item-->

              <!--vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </!--vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>CSV</span>
                </span>
              </vs-dropdown-item>-->

            </vs-dropdown-menu>
          </vs-dropdown>
      </div>


      <!-- AgGrid Table floatingFilter="true"-->
      <!--:onGridReady="onGridReady" -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usersData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        >
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>
  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererCreateDate from './cell-renderer/CellRendererCreateDate.vue'
import CellRendererBank from './cell-renderer/CellRendererBank.vue'
import { createHelpers } from 'vuex-map-fields'
const { mapFields } = createHelpers({
  getterType: `historyManagement/getField`,
  mutationType: `historyManagement/updateField`,
});
export default {
  components: {
    AgGridVue,
    vSelect,
    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererCreateDate,
    CellRendererBank
  },
  data () {
    return {
      qty:100,
      userId:0,
      selected: -1,
      // Filter Options
      roleFilter: { label: 'All', value: 'all' },
      roleOptions: [
        { label: 'All', value: 'all' },
        { label: 'Admin', value: 'admin' },
        { label: 'User', value: 'user' },
        { label: 'Staff', value: 'staff' }
      ],

      statusFilter: { label: 'All', value: 'all' },
      isVerifiedFilter: { label: 'All', value: 'all' },
      isVerifiedOptions: [
        { label: 'All', value: 'all' },
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' }
      ],

      departmentFilter: { label: 'All', value: 'all' },
      departmentOptions: [
        { label: 'All', value: 'all' },
        { label: 'Sales', value: 'sales' },
        { label: 'Development', value: 'development' },
        { label: 'Management', value: 'management' }
      ],

      searchQuery: '',

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        editable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'code',
          width: 250,
          filter: true,
          cellRendererFramework: 'CellRendererLink'
        },
        /*{
          headerName: 'Line name',
          field: 'linename',
          filter: true,
          width: 200
        },*/
        {
          headerName: 'Firstname',
          field: 'firstname',
          filter: true,
          width: 200
        },
        {
          headerName: 'Lastname',
          field: 'lastname',
          filter: true,
          width: 200
        },
        {
          headerName: 'Bank',
          field: 'bank',
          filter: true,
          width: 150,
          cellRendererFramework: 'CellRendererBank'
        },
        {
          headerName: 'Account No.',
          field: 'account_no',
          filter: true,
          width: 200
        },
        {
          headerName: 'Amount',
          field: 'qty',
          filter: true,
          width: 200,
        },
        {
          headerName: 'Create Date',
          field: 'createdate',
          filter: true,
          width: 200,
          cellRendererFramework: 'CellRendererCreateDate'
        },
        {
          headerName: 'Status',
          field: 'status',
          filter: true,
          width: 150,
          cellRendererFramework: 'CellRendererStatus'
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererCreateDate,
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererBank
      }
    }
  },
  watch: {
    roleFilter (obj) {
      this.setColumnFilter('role', obj.value)
    },
    statusFilter (obj) {
      this.setColumnFilter('status', obj.value)
    },
    departmentFilter (obj) {
      this.setColumnFilter('department', obj.value)
    }
  },
  computed: {
    ...mapFields([
        'popup',
        'popup2',
    ]),
    userOption(){
      return this.$store.state.userManagement.userOption
    },
    usersData () {
      return this.$store.state.historyManagement.deposit
    },
    paginationPageSize () {
      //if (this.gridApi) return this.gridApi.paginationGetPageSize()
      return 100
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    createDeposit(){
      if(this.qty && this.userId){
        if(this.userId.userId){
          this.$store.dispatch('historyManagement/createHistory',{userId:this.userId.userId,qty:this.qty,type:'ฝาก'}).catch(err => { console.error(err) }).then(()=>{this.qty = 100;this.userId=0;});
        }
      }
    },
    updateStatus(){
      if(this.selected != -1){
        this.$store.dispatch('historyManagement/updateStatus',this.selected).catch(err => { console.error(err) }).then(()=>{this.selected = -1;});
      }
    },
    onGridReady(params){
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
        this.gridApi.sizeColumnsToFit();
        window.onresize = () => {
            this.gridApi.sizeColumnsToFit();
        }
    },
    /*confirmDeleteRecord (data) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${data}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    async deleteRecord () {
      for(const data of this.gridApi.getSelectedRows()){
        const emailKey = data.email.trim().replace(/\./g, '||');
        await firebase.database().ref().child(`users/${emailKey}`).remove();
      }
      this.showDeleteSuccess()
      this.$store.dispatch('depositManagement/fetchHistory').catch(err => { console.error(err) })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    },*/
    Add(){
      this.$store.dispatch('userManagement/getUsersOption').catch(err => { console.error(err) })
      this.$store.commit('historyManagement/SET_POPUP2',true);
      //this.$router.push('/management/user/form')
    },
    /*Delete(){
      if(this.gridApi.getSelectedRows().length){
        let text = ''
        for(const data of this.gridApi.getSelectedRows()){
          text += (text)?', '+data.firstname:data.firstname
        }
        this.confirmDeleteRecord(text);
      }
    },*/
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    if(window.innerWidth>1000)
    setTimeout( ()=> this.gridApi.sizeColumnsToFit(), 0 );
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
    /*const created = firebase.database().ref('users');
    created.on("child_changed", snapshot => {
      this.$store.dispatch('userManagement/updateUsers',{key:snapshot.key,value:snapshot.val()}).catch(err => { console.error(err) })
    });
    created.on("child_added", () => {
      this.$store.dispatch('userManagement/fetchUsers').catch(err => { console.error(err) })
    });*/
  },
  created () {
    //this.$store.commit('historyManagement/SET_DEPOSIT',[]);
    //this.$store.dispatch('historyManagement/fetchDeposit').catch(err => { console.error(err) })
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
